import * as React from "react";

function Inventory(props) {
  return (
    <svg width={18} height={21} fill="none" {...props}>
      <path
        d="M17.721 5.64v-.083l-.063-.158a.752.752 0 00-.073-.094.988.988 0 00-.095-.126l-.094-.074-.168-.084L9.353.16a1.05 1.05 0 00-1.113 0L.428 5.02l-.095.084-.094.074a.987.987 0 00-.095.126.746.746 0 00-.073.094l-.063.158v.084c-.01.09-.01.182 0 .273v9.177a1.05 1.05 0 00.493.892l7.875 4.862a.49.49 0 00.158.063h.084a.902.902 0 00.546 0h.084a.49.49 0 00.157-.063l7.823-4.862a1.05 1.05 0 00.493-.892V5.914c.01-.091.01-.183 0-.273zM7.778 18.074l-5.775-3.57v-6.7l5.775 3.56v6.71zm1.05-8.526l-5.88-3.633 5.88-3.623 5.88 3.623-5.88 3.633zm6.825 4.956l-5.775 3.57v-6.71l5.775-3.56v6.7z"
        stroke="none"
        fill="currentColor"
      />
    </svg>
  );
}

const InventoryIcon = React.memo(Inventory);
export default InventoryIcon;
